<app-toast-container></app-toast-container>
<div class="wrapper text-white" [ngClass]="roleClass()">
  <app-header></app-header>
  <app-navbar></app-navbar>
  <main class="container mt-3 pb-50 main-container">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
